export function canManagePlatformSettings(session) {
  return session?.principal?.type === "user" && session?.scope?.organizationId === "aiharness" &&
    session?.roles?.includes("platform_admin") === true;
}

export function canEnableReadySolution(item) {
  return item?.supported === true && item?.ready === true;
}

export function readySolutionPublicationIntent(item, previous, createKey) {
  // A retry after a lost response must replay the original publication.
  return previous || { revision: item.deploymentRevision, key: createKey("ready-solution") };
}

export function publishReadySolution(api, item, intent) {
  return api.request(`/v1/platform/ready-solutions/${encodeURIComponent(item.solutionId)}/publish-implementation`, {
    method: "POST", body: {}, headers: {
      "X-AI-Build-Expected-Revision": String(intent.revision), "Idempotency-Key": intent.key,
    },
  });
}

export function setReadySolutionEnabled(api, item, enabled) {
  return api.request(`/v1/platform/ready-solutions/${encodeURIComponent(item.solutionId)}`, {
    method: "PUT", body: { revision: item.revision, enabled },
  });
}
